<template>
  <div
    id="floatBtn"
    class="floating-buttons"
  >
    <div
      v-if="isVisible"
      class="floating-buttons__wrapper-top"
      @click="scrollTop"
    >
      <img
        src="/static/images/site/arrow-up.svg"
        alt="voltar para topo da pagina"
      >
    </div>
    <div
      v-else
      class="floating-buttons__placeholder"
    />
    <div class="floating-buttons__wrapper">
      <a href="https://alvaroapoio.com.br/fale-conosco/contato">
        <img
          src="/static/images/site/btn-cart.svg"
          alt="carrinho"
        >
      </a>
    </div>
    <div class="floating-buttons__wrapper">
      <a href="https://alvaroapoio.com.br/fale-conosco">
        <img
          src="/static/images/site/btn-help.svg"
          alt="ajuda"
        >
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FloatingButtons',
  data: () => ({
    isVisible: false
  }),
  created() {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    scrollTop() {
      window.scrollTo(0, 0)
    },
    handleScroll() {
      if (window.pageYOffset > 125) {
        this.isVisible = true
      } else {
        this.isVisible = false
      }
    }
  }
}
</script>

<style lang="scss">
.floating-buttons {
  position: fixed;
  z-index: 9999;
  display: flex;
  flex-wrap: wrap;
  max-width: 45px;
  right: 16px;
  bottom: 0;

  &--absolute {
    position: absolute;
    top: -50px;
    bottom: auto;
  }

  img {
    max-width: 45px;
  }

  &__placeholder {
    width: 45px;
    height: 45px;
    border-radius: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 15px;
  }
  &__wrapper {
    width: 45px;
    height: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #ff5152;
    border-radius: 100%;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    margin-bottom: 15px;

    &:hover {
      background-color: #e74b4c;
    }
    a {
      width: 45px;
      height: 45px;
      border-radius: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &-top {
      background-color: #7f1a54;
      width: 45px;
      height: 45px;
      border-radius: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 15px;
      box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
      cursor: pointer;

      &:hover {
        background-color: #651744;
      }
    }
  }
}
</style>
